module.exports = __webpack_public_path__ + "img/blog_banner.253be3d2.webp";